(() => {
  class PHCGiftBox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-phc-box-open]');
      this.addEventListener('click', event => {
        const open = event.target.closest('[data-phc-box-open]');
        const close = event.target.closest('[data-phc-box-close]');
        const view = event.target.closest('[data-phc-box-view]');
        if (open) {
          this.querySelectorAll('img').forEach(image => image.loading = 'eager');
          this.showView('closed');
          this.dialog.showModal();
        } else if (close || event.target === this.dialog) {
          this.dialog.close();
        } else if (view) {
          this.showView(view.dataset.phcBoxView);
        }
      });
      this.dialog.addEventListener('close', () => this.trigger.focus());
    }
    showView(view) {
      this.querySelectorAll('[data-phc-box-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.phcBoxView === view)));
      this.querySelectorAll('[data-phc-box-photo]').forEach(photo => photo.hidden = photo.dataset.phcBoxPhoto !== view);
    }
  }
  customElements.define('phc-gift-box', PHCGiftBox);
})();
